import { Base2Presenter } from "core/presenter";
import { OptionalGroupRepository } from "core/repository";

class ProductFormGeneralInfoPresenter extends Base2Presenter {
  initialState() {
    return {
      newOptionalGroupUuids: [],
      allOptionalGroups: [],
      pagination: { page: 1, perPage: 25, totalPage: 1 },
      filters: {}
    };
  }

  onChangeProps() {
    this.loadLinkedOptionalGroups();
  }

  async onStart() {
    await this.loadAllOptionalGroups();
  }

  loadLinkedOptionalGroups() {
    const optionalGroupsUuids = this.props.optionalGroupsUuids
      ? this.props.optionalGroupsUuids
      : [];
    this.enqueue({ newOptionalGroupUuids: optionalGroupsUuids });
  }

  clearLinkedOptionalGroups() {
    const newOptionalGroupUuids = this.props.optionalGroupsUuids || [];
    this.enqueue({ newOptionalGroupUuids });
  }

  async getOptionalGroupsFilters(filter) {
    const currentUser = await this.mRuntime.get("currentUser");
    const companyUuid = currentUser.company_uuid;
    return [
      { connector: "AND", field: "name", operation: "LIKE", value: filter },
      {
        connector: "AND",
        field: "company_uuid",
        operation: "EQ",
        value: companyUuid
      },
      { connector: "AND", field: "enabled", operation: "EQ", value: "true" },
      { connector: "AND", field: "deleted", operation: "EQ", value: "false" }
    ];
  }

  handleFilterChange = filter => {
    this.enqueue(
      { filter },
      async () => await this.loadAllOptionalGroups(filter.name)
    );
  };

  async loadAllOptionalGroups(viewFilters) {
    this.enqueue({ loading: true });
    const filters = await this.getOptionalGroupsFilters(viewFilters);
    const { pagination } = this.viewModel;
    const order = [{ field: "name", direction: "ASC" }];

    const repositoryResult = await OptionalGroupRepository.getListOnline({
      order,
      pagination,
      filters
    });

    if (repositoryResult.success) {
      const totalPage = Math.ceil(
        parseInt(repositoryResult.total, 10) /
          parseFloat(repositoryResult.perPage)
      );
      this.enqueue(vm => ({
        allOptionalGroups: repositoryResult.data,
        pagination: { ...vm.pagination, totalPage }
      }));
    } else if (repositoryResult.fatal) {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Nosso serviço encontra-se indisponível. Tente novamente mais tarde."
      });
    } else {
      this.sendNotification({
        type: "error",
        title: "Oops...",
        content:
          "Não foi possível carregar os grupos de opcionais. Tente novamente mais tarde."
      });
    }

    this.enqueue({ loading: false });
  }

  onCheckOptionalGroup(checked, uuid) {
    // add the uuid if true
    // remove if false
    // enqueue the new array on the newOptionalGroupUuids (so then it filters)
    const newArray = this.viewModel.newOptionalGroupUuids;
    const alreadyExists = newArray.includes(uuid);
    let index;
    if (alreadyExists) {
      if (!checked) {
        index = newArray.indexOf(uuid);
        newArray.splice(index, 1);
      }
    } else {
      newArray.push(uuid);
    }
    this.enqueue({ newOptionalGroupUuids: newArray });
  }

  async onPageChange(page) {
    const actualPage = page === this.viewModel.pagination.page;
    const pageLtZero = page < 1;
    const pageGtTotal = page > this.viewModel.pagination.totalPage;
    if (actualPage || pageLtZero || pageGtTotal) {
      return;
    }

    this.enqueue(
      vm => {
        if (page < 1) {
          return { pagination: { ...vm.pagination, page: 1 } };
        } else if (page > vm.pagination.totalPage) {
          return {
            pagination: { ...vm.pagination, page: vm.pagination.totalPage }
          };
        } else {
          return { pagination: { ...vm.pagination, page } };
        }
      },
      async () => await this.loadAllOptionalGroups()
    );
  }

  resetModal() {
    this.enqueue(vm => ({
      filters: { ...vm.filters, name: "" },
      pagination: { ...vm.pagination, page: 1 }
    }));
  }
}
export default ProductFormGeneralInfoPresenter;



// WEBPACK FOOTER //
// ./src/components/app/registration/product/form/general-info/optional-groups/presenter.js